module.exports = __webpack_public_path__ + "img/weather51.3fcefa55.png";